import React, { useState, useEffect, useContext } from 'react';

import Container from 'react-bootstrap/Container';
import Button from '@material-ui/core/Button';

import { AccountContext } from '../../auth/Accounts';
import Loader from '../../Loading';
import API from '../../../api';
import { withSnackbar } from "../../HOC/Alert";
import RefreshAPIKeyModal from './Modals/RefreshAPIKeyModal';

function PTTab(props) {
    const [loading, setLoading] = useState(false)
    const [hasKey, setHasKey] = useState(false)
    const [showModal, setShowModal] = useState(false)

    const { getSession } = useContext(AccountContext);

    const fetchKey = () => {
        getSession()
            .then(session => {
                setLoading(true);
                API.get("/org_settings/wint", {
                    headers: { "Authorization": session.idToken.jwtToken },
                    params: { org_name: session.idToken.payload.name }
                })
                    .then(res => {
                        setLoading(false);
                        setHasKey(!!res.data)
                    })
                    .catch(err => {
                        setLoading(false);
                        const message = err.response?.data?.detail || err.response?.data || "Failed to load API key status";
                        props.showAlert(message, "error");
                    })
            })
    }

    useEffect(() => { fetchKey() }, []);

    const handleSuccess = () => {
        props.showAlert("API Key Refreshed");
        fetchKey();
    }

    return (
        <Container className="mt-3">
            {loading ? <Loader /> :
                <>
                    <p>
                        <strong>API Key Status: </strong>
                        {hasKey ? "Configured" : "Not configured"}
                    </p>
                    <Button variant="contained" color="primary" onClick={() => setShowModal(true)}>
                        Refresh API Key
                    </Button>
                    <RefreshAPIKeyModal
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        onSuccess={handleSuccess}
                    />
                </>
            }
        </Container>
    );
}

export default withSnackbar(PTTab);
